import React, { FC } from 'react';
import Select, { MultiValue } from 'react-select';
//import styles from './MultiSelectWithFiltering.module.css';

type Option = {
  value: string;
  label: string;
};

interface MultiSelectWithFilteringProps {
  options: Option[];
  defaultValues?: Option[];
  value?: Option[];
  placeholder?: string;
  name: string;
  inputId: string;
  onSelect: (selectedValues: MultiValue<Option>) => void;
}

const MultiSelectWithFiltering: FC<MultiSelectWithFilteringProps> = ({
  options,
  placeholder = 'Select...',
  defaultValues = [],
  value = [],
  name,
  inputId,
  onSelect,
}) => {
  return (
    <Select
      isMulti
      name={name}
      inputId={inputId}
      closeMenuOnSelect={false}
      placeholder={placeholder}
      defaultValue={defaultValues}
      onChange={onSelect}
      options={options}
      value={value}
      styles={{
        multiValueRemove: (styles) => ({
          ...styles,
          ':hover': {
            backgroundColor: 'hsl(0, 0%, 80%)',
          },
        }),
        control: (base) => ({
          ...base,
          border: '1px solid #dee2e6',
          borderRadius: '4px',
          ':hover': {
            border: '1px solid #dee2e6',
          },
        }),
      }}
      theme={(theme) => ({
        ...theme,
        borderRadius: 0,
        colors: {
          ...theme.colors,
          primary25: '#dee2e6',
          primary: 'none',
        },
      })}
    />
  );
};

export default MultiSelectWithFiltering;
